import './SocialLinks.sass'

const SocialLinks = ({ title, links = [] }) => (
  <div className='social-links-wrapper'>
    {title && <p>{title}</p>}
    <ul>
      {links.map(({ url, icon, title }, index) => (
        <li key={index}>
          <a href={url} target="_blank" rel="noreferrer nofollow">
            <img src={icon?.url} alt={title} />
          </a>
        </li>
      ))}
    </ul>
  </div>
)

export default SocialLinks
